export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"theme-color","content":"#31576F"}],"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"},{"rel":"manifest","href":"/manifest.json"},{"rel":"icon","type":"image/png","sizes":"48x48","href":"/image/favicon-48x48.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/image/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/image/favicon-16x16.png"},{"rel":"apple-touch-icon-precomposed","sizes":"144x144","href":"/image/apple-touch-icon-144x144-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"120x120","href":"/image/apple-touch-icon-120x120-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"114x114","href":"/image/apple-touch-icon-114x114-precomposed.png"},{"rel":"apple-touch-icon-precomposed","sizes":"72x72","href":"/image/apple-touch-icon-72x72-precomposed.png"},{"rel":"apple-touch-icon-precomposed","href":"/image/apple-touch-icon-57x57-precomposed.png"}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true